import { Changeset } from 'ember-changeset';
import {
  ChannelPromotionChannel,
  ChannelPromotionStatus,
  ChannelPromotionType,
} from 'uplisting-frontend/models/channel-promotion';
import BaseRepositoryService, {
  type GenericChangeset,
} from 'uplisting-frontend/services/repositories/-base';
import type { ModelRegistry } from 'ember-data/types/registries/model';
import {
  ChannelPromotionEarlyBookingValidation,
  ChannelPromotionLastMinuteValidation,
  ChannelPromotionNewListingValidation,
  ChannelPromotionMobileOnlyValidation,
  ChannelPromotionMemberOnlyValidation,
} from 'uplisting-frontend/validations';
import lookupValidator from 'ember-changeset-validations';

const validationForType = {
  [ChannelPromotionType.earlyBooking]: ChannelPromotionEarlyBookingValidation,
  [ChannelPromotionType.lastMinute]: ChannelPromotionLastMinuteValidation,
  [ChannelPromotionType.newListing]: ChannelPromotionNewListingValidation,
  [ChannelPromotionType.mobileOnly]: ChannelPromotionMobileOnlyValidation,
  [ChannelPromotionType.memberOnly]: ChannelPromotionMemberOnlyValidation,
};

export default class ChannelPromotionRepositoryService extends BaseRepositoryService<
  ModelRegistry['channel-promotion']
> {
  recordName = 'channel-promotion';
  implementMethods = ['buildChangeset', 'createRecord', 'save'];

  validation = ChannelPromotionEarlyBookingValidation;

  public changesetForType(
    property: ModelRegistry['property'],
    type: ChannelPromotionType,
  ): GenericChangeset<ModelRegistry['channel-promotion']> {
    const promotion = property.channelPromotions.find(
      (item) =>
        item.type === type && item.channel === ChannelPromotionChannel.homeaway,
    );

    const record =
      promotion ||
      this.createRecord({
        channel: ChannelPromotionChannel.homeaway,
        status: ChannelPromotionStatus.inactive,
        type,
        ...(type === ChannelPromotionType.memberOnly ? { tiers: {} } : {}),
      });

    const validation = validationForType[type];

    return Changeset(
      record,
      lookupValidator(validation),
      validation,
    ) as GenericChangeset<ModelRegistry['channel-promotion']>;
  }
}

declare module '@ember/service' {
  interface Registry {
    'repositories/channel-promotion': ChannelPromotionRepositoryService;
  }
}
